import { __assign } from "tslib";
import Cookies from 'universal-cookie';
import whereami from '../utils/whereami';
import { getParsedValue, getStringValue } from './utils/parser';
var useCookies = function (ctx, parsers) {
    var _a, _b;
    var headerCookies = whereami.isServerSide ? (_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx.req) === null || _a === void 0 ? void 0 : _a.headers) === null || _b === void 0 ? void 0 : _b.cookie : undefined;
    var cookies = new Cookies(headerCookies);
    var getCookies = function (options) {
        if (options === void 0) { options = {}; }
        var allCookies = cookies.getAll(__assign(__assign({}, options), { doNotParse: true }));
        return Object.entries(allCookies).reduce(function (acc, _a) {
            var _b;
            var key = _a[0], value = _a[1];
            return (__assign(__assign({}, acc), (_b = {}, _b[key] = getParsedValue(key, value, parsers), _b)));
        }, {});
    };
    var getCookie = function (name, options) {
        if (options === void 0) { options = {}; }
        var value = cookies.get(name, __assign(__assign({}, options), { doNotParse: true }));
        return getParsedValue(name, value, parsers);
    };
    var setCookie = function (name, value, options) {
        return cookies.set(name, getStringValue(name, value, parsers), options);
    };
    var delCookie = function (name, options) {
        return cookies.remove(name, options);
    };
    return {
        getCookies: getCookies,
        getCookie: getCookie,
        setCookie: setCookie,
        delCookie: delCookie,
    };
};
export default useCookies;
//# sourceMappingURL=useCookies.js.map